import * as theme from '@zero/design-tokens/build/js/variables';
import styled from 'styled-components';
import { Button } from 'uol-host-react-ui'
import { device } from 'uol-host-react-ui/dist/atoms/Pagination/devices'
interface ListQuestionProps {
    lenght: number
}

export const ListQuestion = styled.div<ListQuestionProps>`
    width: 100%;

    @media ${device.tablet} {
        width: 100%;
    }
`

export const TitleQuestion = styled.h2`
    color: #444444;
    font-size: 20px;
    font-family: 'UOLText', Arial, Helvetica, sans-serif;
    font-weight: bold;
    margin-bottom: ${theme.ZrSpacingVerticalXs};
    
    @media ${device.mobileLM} {
        margin-bottom: ${theme.ZrSpacingVerticalSm};
    }

    @media only screen and (max-width: 880px) {
        font-size: 18px;
    }

    @media ${device.tablet} {
        text-align: center;
    }
`;

export const LabelRadio = styled.label`
    color: ${theme.ZrColorNeutralMedium01};
    font-size: ${theme.ZrFontSizeMicro};
    margin-left: ${theme.ZrSpacingHorizontalMicro};
    margin-bottom: 0px;
    cursor: pointer;
`;

export const ContainerQuestion = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: center;

    .box-radio{
        display: flex;
        margin-bottom: ${theme.ZrSpacingVerticalXxxs};
        cursor: pointer;
    }
    [type=radio]{
        margin: 0px 0 0;
    }

    //animação começo

    .fade-animation {
        animation:fadeIn 0.3s linear;
    }

    @keyframes fadeIn {
    0% {
        opacity:0
    }
    100% {
        opacity:1;
    }
    }

    .questionsElements.none {
        display:none
    }

    @media ${device.tablet} {
        flex-direction: column;
        align-items: center;
    }
    //animação fim
`
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: auto;
    flex: 1;
`;

export const ContainerButtons = styled.div`
    display: flex;
    flex-direction: row;
    width: 80%;
    justify-content: center;
    margin-top: auto;

    @media ${device.laptop} {
        width: 90%;
    }

    @media ${device.tablet} {
        flex-direction: column-reverse;
        width: 100%;
    }
`;

export const ContainerAnswers = styled.div`
    margin: 0 50px 30px;
    
    @media ${device.tablet} {
        min-width: 360px;
        margin: 0 0 30px;
    }

    @media (max-width: 423px){
        min-width: 0;
    }

`;

export const QuestionsRender = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
`;

export const ButtonCustom = styled(Button)`
    width: 40%;
    max-width: 300px;
    margin: 0px 15px;

    @media only screen and (max-width: 880px) {
        font-size: ${theme.ZrFontSizeXxs};
    }
    @media ${device.tablet} {
        margin:0px 0px;
        width: 100%;
        max-width: 100%;
        font-size: ${theme.ZrFontSizeXxs};
        margin-top: ${theme.ZrSpacingVerticalXxs};
    }
    `;

